var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgECoolingValveDistr = function SvgECoolingValveDistr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 326,
    width: 10,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.04,
    y: 339,
    width: 10.01,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "24.86 326.5 39.14 326.51 31.99 338.99 24.86 326.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.72,327h12.55s-6.29,10.98-6.29,10.98l-6.27-10.98M24,326l7.99,14,8.01-13.99h-16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "24.86 353.49 31.99 341.01 39.14 353.5 24.86 353.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.99,342.02l6.29,10.98h-12.55s6.27-10.98,6.27-10.98M31.99,340l-7.99,13.99h16s-8.01-13.99-8.01-13.99h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 340,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,330c5.51,0,10,4.49,10,10s-4.49,10-10,10-10-4.49-10-10,4.49-10,10-10M11,329c-6.08,0-11,4.92-11,11s4.92,11,11,11,11-4.92,11-11-4.92-11-11-11h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.36,336.65l1.64,4.36,1.64-4.36h1.28v5.69h-.98v-1.88l.1-2.51-1.68,4.38h-.71l-1.68-4.38.1,2.5v1.88h-.98v-5.69h1.28Z"
  })))));
};
export default SvgECoolingValveDistr;